<template>
  <button class="w-table-header__button" @click="toggle">
    <plus :color="color" v-if="!isOpen" class="wizard-section__icon"/>
    <minus :color="color" v-if="isOpen" class="wizard-section__icon"/>
  </button>
</template>

<script>
import Plus from '@/components/icons/Plus.vue';
import Minus from '@/components/icons/Minus.vue';

export default {
  components: {
    Plus,
    Minus,
  },
  props: {
    opened: {
      type: Boolean,
      default: false,
    },
    className: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: '004480',
    },
  },
  data: () => ({
    isOpen: false,
  }),
  methods: {
    toggle(value) {
      if (this.isOpen) {
        this.$emit('closed', value);
        this.isOpen = false;
      } else {
        this.$emit('opened', value);
        this.isOpen = true;
      }
    },
  },
  mounted() {
    this.isOpen = this.opened;
  },
  watch: {
    opened(value) {
      this.isOpen = value;
    },
  },
};
</script>
<style>
button:focus {
  outline: none!important;
}
.w-table {
  border-collapse: collapse;
  font-size: inherit;
  width: 100%;
}
.w-table-header {
  align-items: center;
  display: flex;
}
.w-table-header__icon {
  color: #00A5DD;
  height: 1.25rem;
  margin-right: 0.3125rem;
  width: 1.25rem;
}
.w-table-header__heading {
  color: #004480;
  font-size: 1.25rem;
  margin: 0 auto 0 0;
}
.w-table-header__button {
  background-color: transparent;
  border: none;
  cursor: pointer;
  height: 2.5rem;
  margin-bottom: -0.3125rem;
  margin-top: -0.3125rem;
  width: 2.5rem;
}
.w-accordion {
  font-family: var(--font-family-secondary);
  font-size: 1.125rem;
  line-height: 1.5625rem;
}
.w-accordion__content {
  padding-top: 0.3125rem;
}
.w-accordion.-lines + .w-accordion.-lines {
  border-top: 1px solid var(--color-neutral-400);
}
.w-accordion.-lines .w-accordion__header {
  line-height: 2.5rem;
}
.w-accordion.-lines .w-accordion__content {
  border-top: 1px solid var(--color-neutral-400);
  padding-bottom: 0.4375rem;
  padding-top: 0.4375rem;
}
.w-accordion.-lines .w-accordion__content .w-accordion__header {
  margin-bottom: -0.4375rem;
  margin-top: -0.4375rem;
}
.w-accordion.-lines .w-accordion__content .w-accordion__content {
  margin-top: 0.4375rem;
  padding-bottom: 0;
  padding-left: 2.5rem;
}
.w-accordion__header {
  transition-property: color;
  transition-duration: 0.12s;
  transition-timing-function: ease;
  align-items: center;
  appearance: none;
  background-color: transparent;
  border: none;
  color: inherit;
  display: flex;
  font-family: var(--font-family-secondary);
  font-weight: 600;
  justify-content: space-between;
  line-height: 1.5625rem;
  padding: 0 0.625rem 0 0;
  text-align: left;
  width: 100%;
}
.w-accordion__header:focus {
  outline: 2px dashed var(--color-secondary-500);
  outline-offset: 2px;
}
.w-accordion__header:focus:not(:focus-visible) {
  outline: none;
}
.w-accordion__header:focus-visible {
  outline: 2px dashed var(--color-secondary-500);
  outline-offset: 2px;
}
.w-accordion__header:where(:focus), .w-accordion__header:where(:focus-visible) {
  position: relative;
}
.w-table-header__heading{
  color: var(--color-primary-400);
  font-weight: normal;
}
.w-table-header__button svg {
  fill: var(--color-primary-600);
  width:15px;
  height:15px;
}
</style>
